import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ba04f04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hr-mail-settings" }
const _hoisted_2 = {
  key: 0,
  class: "hr-mail-error",
  role: "alert"
}
const _hoisted_3 = {
  key: 1,
  role: "status"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = ["required"]
const _hoisted_7 = ["required"]

import { onMounted, reactive, ref } from "vue";
import { Button } from "@/components/common";
import HrDataService from "@/services/hr/HrDataService";
import { HrNotificationSettings } from "@/types/hr/Hr";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

/* Legacy ESLint does not detect template usage from script setup. */
/* eslint-disable @typescript-eslint/no-unused-vars */
const form = reactive<HrNotificationSettings>({
  enabled: false,
  contactName: "",
  contactEmail: "",
  contactPhone: "",
});
const loading = ref(true);
const loaded = ref(false);
const saving = ref(false);
const success = ref(false);
const error = ref("");

onMounted(async () => {
  try {
    const response = await HrDataService.getNotificationSettings();
    const settings = response.data.data;
    Object.assign(form, {
      enabled: settings.enabled,
      contactName: settings.contactName || "",
      contactEmail: settings.contactEmail || "",
      contactPhone: settings.contactPhone || "",
    });
    loaded.value = true;
  } catch {
    error.value = t("hr.mailSettingsLoadError");
  } finally {
    loading.value = false;
  }
});

async function save() {
  if (saving.value || !loaded.value) return;
  error.value = "";
  success.value = false;
  saving.value = true;
  try {
    await HrDataService.saveNotificationSettings({ ...form });
    success.value = true;
  } catch (exception: unknown) {
    const response = exception as {
      response?: { data?: { message?: string } };
    };
    error.value = response.response?.data?.message || t("hr.saveError");
  } finally {
    saving.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_unref(t)("hr.mailSettings")), 1),
    _createElementVNode("p", null, _toDisplayString(_unref(t)("hr.mailSettingsHint")), 1),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true),
    (success.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)("hr.settingsSaved")), 1))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(t)("hr.loading")), 1))
      : (_openBlock(), _createElementBlock("form", {
          key: 3,
          onSubmit: _withModifiers(save, ["prevent"])
        }, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).enabled) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, _unref(form).enabled]
            ]),
            _createTextVNode(_toDisplayString(_unref(t)("hr.mailEnabled")), 1)
          ]),
          _createElementVNode("label", null, [
            _createTextVNode(_toDisplayString(_unref(t)("hr.contactName")), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).contactName) = $event)),
              class: "input-form",
              maxlength: "200",
              required: _unref(form).enabled
            }, null, 8, _hoisted_6), [
              [
                _vModelText,
                _unref(form).contactName,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          _createElementVNode("label", null, [
            _createTextVNode(_toDisplayString(_unref(t)("hr.contactEmail")), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).contactEmail) = $event)),
              class: "input-form",
              type: "email",
              maxlength: "100",
              required: _unref(form).enabled
            }, null, 8, _hoisted_7), [
              [
                _vModelText,
                _unref(form).contactEmail,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          _createElementVNode("label", null, [
            _createTextVNode(_toDisplayString(_unref(t)("hr.contactPhone")), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).contactPhone) = $event)),
              class: "input-form",
              maxlength: "30"
            }, null, 512), [
              [
                _vModelText,
                _unref(form).contactPhone,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          _createVNode(_unref(Button), {
            type: "submit",
            disabled: saving.value || !loaded.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(saving.value ? _unref(t)("hr.saving") : _unref(t)("common.save")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 40, _hoisted_5))
  ]))
}
}

})